import React, {Fragment, memo} from 'react';
import './_aboutComposerResidence.scss';
import Popup, {showPopup} from "../popup/popup";

function AboutComposerResidence({residence}) {
    return (
        <>

            <section className='aboutComposerResidenceBlock' id='composerInResidence'>
                <h3>COMPOSER-IN-RESIDENCE</h3>
                {residence && residence.map((residenceItem,i) =>
                    <Fragment key={i}>
                        <div className='composerPopupContainer'>
                            <Popup videoUrl={residenceItem.video_link} parentClass={'.composerPopupContainer'}/>
                        </div>
                        <div className='aboutComposerResidenceBody'>
                            <div className='mainInfo'>
                                <div className='composer'/>
                                <div className='composerInfo'>
                                    <h3>{residenceItem.name}</h3>
                                    <p>{residenceItem.position}</p>
                                </div>
                            </div>
                            <div className='bioInfo'>
                                <p className='titleText'>{residenceItem.title}</p>
                                <p dangerouslySetInnerHTML={{__html: residenceItem.text}}/>
                                <button className='openComposerPopup'
                                        onClick={() => showPopup('.composerPopupContainer')}>
                                    Watch&nbsp;Video
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </section>
        </>
    );
}

export default memo(AboutComposerResidence);
